import { cn } from '@utils/cn';

import { Icon } from '@ui-component-library/components/Icon';
import { Text } from '@ui-component-library/components/Text';

import type { HelperTextProps } from './HelperText.types';

import { helperClasses } from './HelperText.styles';

function HelperText({ className, icon, label }: HelperTextProps) {
  return (
    <div className={cn(helperClasses(), className)}>
      {icon && <Icon name={icon} size="medium" />}
      <Text variant="text-xs/leading-normal/normal">{label}</Text>
    </div>
  );
}

export { HelperText };
